// MHM-5 — Theme-aware Leaflet TileLayer wrapper.
// Light → OpenStreetMap · Dark → CartoDB Dark Matter (no key, free).
import { TileLayer } from "react-leaflet";
import { useTheme } from "../../contexts/ThemeContext";

const LIGHT = {
  url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
  attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
  subdomains: "abc",
};
const DARK = {
  url: "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png",
  attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> · &copy; <a href="https://carto.com/">CARTO</a>',
  subdomains: "abcd",
};

export default function ThemedTileLayer() {
  const { effective } = useTheme();
  const cfg = effective === "dark" ? DARK : LIGHT;
  // key=effective forces remount so the tile URL swap takes immediate effect
  return <TileLayer key={effective} url={cfg.url} attribution={cfg.attribution}
                    subdomains={cfg.subdomains} />;
}
